import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";
import { Container, Tabs, Tab } from "react-bootstrap";
import PlanningFrom from "./Tabs/PlanningForm";
import EventPlanningDetail from "./Tabs/EventPlaningDetail";
import WorkCalendar from "./Tabs/calendar";
import TechnicianPlansService from "../../../services/technicianplan.service";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import { useAlert } from "../../../context/AlertContext";
import { getQueryString } from "../../../utils/Query";
import TechniciansService from "../../../services/technician.service";
import JobTypeService from "../../../services/jobtype.service";
import CustomersService from "../../../services/customer.service";
import SequenceStatusService from "../../../services/sequencestatus.service";

export default function HeadEventPlanning() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [selectedTab, setSelectedTab] = useState("");
  const [technicianPlanning, setTechnicianPlanning] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialData, setInitialData] = useState([]);
  const [technicians, setTechnicians] = useState([]);
  const [jobTypes, setJobTypes] = useState([]);
  const [seqNo, setSeqNo] = useState([]);
  const [seqStatus, setSeqStatus] = useState([]);
  const [customerName, setCustomerName] = useState([]);
  useEffect(() => {
    handleChangeTab(state?.name || "EventPlanning");
  }, []);

  const handleChangeTab = (key) => {
    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        EventPlanning: "หัวหน้าวางแผนงาน",
        EventplaningDetail: "ข้อมูลการวางแผน",
        EventplaningCalendar: "ปฏิทินงานช่าง"
      }
    });
  };
  const getData = () => {

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechniciansService.getAllTechnicians(),
      callback: (res) => {
        setTechnicians(res);
      }
    });
    getServiceRequest({
      showAlert,
      setLoading,
      // serviceRequest: JobTypeService.getAllJobTypes(),
      serviceRequest: JobTypeService.getJobTypesForTechPlan(),
      callback: (res) => {
        setJobTypes(res);
      }
    });
  

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: SequenceStatusService.getAllSequenceStatuses(),
      callback: (res) => {
        setSeqStatus(res);
      }
    });
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setInitialData({
      technicians: technicians,
      jobTypes: jobTypes,
      seqStatus: seqStatus
    });
  }, [technicians, jobTypes, seqNo, customerName, seqStatus]);
  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Head Event Planning Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={state?.name || "EventPlanning"}
          onSelect={handleChangeTab}
        >
          <Tab eventKey="EventPlanning" title="หัวหน้าวางแผนงาน">
            {websiteName === "หัวหน้าวางแผนงาน" && <PlanningFrom initialData={initialData} />}
          </Tab>
          <Tab eventKey="EventplaningDetail" title="ข้อมูลการวางแผน">
            {websiteName === "ข้อมูลการวางแผน" && (
              <EventPlanningDetail initialData={initialData} />
            )}
          </Tab>
          <Tab eventKey="EventplaningCalendar" title="ปฏิทินงานช่าง">
            {websiteName === "ปฏิทินงานช่าง" && <WorkCalendar />}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
